import React from 'react'
import { SearchedKnowledgeModel } from '../../../service/api/knowledge'
import './KnowledgesPanel.css'
interface KnowledgeListProps {
    dataSource?: SearchedKnowledgeModel[]
    onItemClick?: (item: SearchedKnowledgeModel) => void
}
const KnowledgeList: React.FC<KnowledgeListProps> = (props) => {
    const { dataSource = [], onItemClick = () => undefined } = props
    return (
        <div className='knowledges-panel'>
            {dataSource.map((item) => (
                <div
                    key={item.k_id}
                    className='knowledge-item'
                    onClick={() => onItemClick(item)}
                >
                    <p className='knowledge-list-item__text'>{item.k_title}</p>
                </div>
            ))}
        </div>
    )
}

export default KnowledgeList
